import {Action} from "../../../action/action";
import type CheckoutState from "../checkoutState";

export class Next extends Action<"NEXT_STATE", undefined> {
  readonly type = "NEXT_STATE";
  protected state: CheckoutState;

  constructor(state: CheckoutState) {
    super(state);
    this.state = state;
  }
  /**
   * Business Logic:
   * This action is available if there isn't any payment left to be handled.
   * If there's payment to be handled, the user has to choose a PaymentMethod.
   * @returns
   */
  public isDoable(): boolean {
    const {priceToPay, paymentMethod} = {...this.state.getData()};

    if (priceToPay === undefined) return false;
    if (priceToPay === 0 || priceToPay === "COVERED") return true;
    if (priceToPay > 0 && paymentMethod) return true;

    // const isThereAnythingToPay = (priceToPay > 0 && paymentMethod) ? true : priceToPay === 0 ? true : false;
    return false;
  }

  public isValid(): boolean {
    return this.isDoable();
  }
}
